/**
 * Vite entry — mounts React into #root.
 */

import ReactDOM from "react-dom/client";
import { registerSW } from "virtual:pwa-register";
import { toast } from "react-toastify";
import { Button } from "@/components/ui/button";
import { pruneStaleWriteAttempts } from "@/lib/writeAttempt";
import i18n from "../i18n";
import App from "./App";

// New service worker downloads and installs in the background as soon as
// it's available; it only takes over (and reloads the page) once the user
// confirms via this toast, so we don't force the page to reload while they
// using it during critical flows.
const updateServiceWorker = registerSW({
  immediate: true,
  onNeedRefresh() {
    toast(
      <div className="flex flex-col gap-2">
        <span>{i18n.t("toasts:appUpdateAvailable")}</span>
        <Button
          size="sm"
          className="self-end bg-mforange text-white hover:bg-mforange/70"
          onClick={() => updateServiceWorker()}
        >
          {i18n.t("toasts:appUpdateReload")}
        </Button>
      </div>,
      { toastId: "appUpdateAvailable", icon: false, autoClose: false }
    );
  },
});

pruneStaleWriteAttempts();

const root = document.getElementById("root") as HTMLElement;
const rootElement = ReactDOM.createRoot(root);

rootElement.render(<App />);
